export enum ActionResult {
  Success = 'Success',
  Error = 'Error',
  Cancel = 'Cancel',
}
